import { DefaultService } from "../DefaultService";

export default class B2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    findAll(situacao, column, order, page = 0, limit = 20, ...params) {
        return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/findall.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}&situacao=${situacao}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/getcombo/b2bempresas.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
            this.handleError(err);
		});
	}

    updateSituacao(empresa) {
		return this._http.post(`${this._env}/b2b/b2bempresa/updatesituacao`, empresa, this._headers).then(res => {
			return res.body;
		}, err => {
			this.handleError(err);
		});
    }

    save(form) {
		return this._http.post(`${this._env}/b2b/b2bempresa`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}